export type TVariant = "standard" | "filled" | "outlined" | undefined;

export type TTabVariant = "standard" | "scrollable" | "fullWidth" | undefined;

export type TLabelPlacement = "start" | "end" | "top" | "bottom" | undefined;

export const DEFAULT_DATE_FORMAT = "dd/MM/yyyy";
